import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=3ef9a94e"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"
import style0 from "./ValidationMessage.vue?vue&type=style&index=0&id=3ef9a94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports